export function formatPrice(price: number, currency: string = "AUD") {
  const formattedPrice = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);

  return formattedPrice;
}
